module.exports = __webpack_public_path__ + "img/1_1-parco-1.788be335.png";